
import { Component, Vue, Prop } from 'vue-property-decorator';
import Price from '@/components/price/index.vue';

@Component({
  components: {
    Price
  }
})
export default class extends Vue {
  @Prop({ default: [] }) recommendList!: [] // 热门列表

  // 浏览更多
  watchMore(id: number) {
    this.$router.push(`/classify?parentTypeId=${id}`);
  }

  private goDetails(id: string) {
    this.$router.push(`/details?id=${id}&from=hotlist`);
  }
}
